import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { useCurrentLanguage, getLocalizedPath } from 'utils/localizedRouting';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);
  const currentLang = useCurrentLanguage();

  if (isLoading) {
    return null; // Or a specific loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to={getLocalizedPath('/', currentLang)} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
